import { HttpErrorResponse } from "@angular/common/http";
import { AddLearnerOfflineActivityDto, EditLearnerOfflineActivityDto, LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";


export interface LearnerOfflineActivityState {
  addOfflineActivity: AddLearnerOfflineActivityDto;
  addOfflineActLoader: boolean;
  addOfflineActError: HttpErrorResponse;
  addOfflineActResult: AddLearnerOfflineActivityDto;
  
  editOfflineActivity: EditLearnerOfflineActivityDto;
  editOfflineActLoader: boolean;
  editOfflineActError: HttpErrorResponse;
  editOfflineActResult: EditLearnerOfflineActivityDto;

  skillSelection: string[];
  skillSelectionLoader: boolean;
  skillSelectionError: any;

  offlineActivity: LearnerLearningRecord,
  offlineActivityLoader: boolean,
  offlineActivityError: HttpErrorResponse,

  previousRoute: string,
}

export const initialLearnerOfflineActivityState: LearnerOfflineActivityState = {
  addOfflineActivity: null,
  addOfflineActLoader: false,
  addOfflineActError: null,
  addOfflineActResult: null,

  editOfflineActivity: null,
  editOfflineActLoader: false,
  editOfflineActError: null,
  editOfflineActResult: null,

  skillSelection: null,
  skillSelectionLoader: false,
  skillSelectionError: null,

  offlineActivity: null,
  offlineActivityLoader: false,
  offlineActivityError: null,
  
  previousRoute: null,
}